import { isNonEmptyString, isObject } from '@/utils/checks'
import { Location } from '../../types/models/Location.model'
import getPageTypeName from '../useCases/getPageTypeName'
import getTypeTittleMapFromLocationList from '../location/useCases/getTypeTitleMapFromLocationList'
import { PageType } from '@/types/models/PageType.model'

export type PageViewProperties = {
  city?: string
  country?: string
  region?: string
  title?: string
  search?: string
  template: string
}
interface GeneratePageViewProperties {
  (props: { location?: Location; pageType: PageType }): PageViewProperties
}

const generatePageViewPropertiesForLocation: GeneratePageViewProperties = ({
  location,
  pageType
}) => {
  const defaultProperties: PageViewProperties = {
    search: window.location.search,
    template: getPageTypeName(pageType),
    title: document.title
  }

  if (!isObject(location)) {
    return defaultProperties
  }

  const addressParts = (location.location_address_parts ||
    location.address_parts ||
    []) as Location[]

  const locations = [location].concat(addressParts)

  return {
    ...defaultProperties,
    ...getTypeTittleMapFromLocationList(locations)
  }
}

export default generatePageViewPropertiesForLocation
